import { Accept, FileRejection } from "react-dropzone";

export const SUPPORTED_DOCUMENT_ACCEPT: Accept = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.ms-excel.sheet.macroenabled.12": [".xlsm"],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
  "text/csv": [".csv"],
  "text/plain": [".txt"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
};

export function unsupportedDocumentUploadMessage(rejections: FileRejection[]) {
  const names = rejections.map(({ file }) => file.name).join(", ");
  return names
    ? `${names} cannot be uploaded. Use a PDF, Office document, CSV, text file, or image.`
    : "Unsupported document type. Use a PDF, Office document, CSV, text file, or image.";
}
